import { initializeApp } from "firebase/app"
import {
  getMessaging,
  getToken as getFirebaseToken,
  deleteToken as deleteFirebaseToken,
  onMessage,
} from "firebase/messaging"

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD6ZCm6zsKtBvX_ZeogqWBawdEZfn8QdsA",
  authDomain: "padhai-chat.firebaseapp.com",
  projectId: "padhai-chat",
  storageBucket: "padhai-chat.appspot.com",
  messagingSenderId: "50961287602",
  appId: "1:50961287602:web:a9ca61872a489ee239fcab",
  measurementId: "G-M5XM35Q3Z0",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)

// Global variable to track if service worker is registered
let serviceWorkerRegistration = null

// Register the service worker for FCM
export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      // Check if we already have a registration
      if (serviceWorkerRegistration) {
        return serviceWorkerRegistration
      }

      // Register the service worker
      const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
        scope: "/",
      })
      console.log("Service Worker registered with scope:", registration.scope)

      // Store the registration for future use
      serviceWorkerRegistration = registration

      // Ensure the service worker is activated
      if (registration.active) {
        console.log("Service worker is already active")
      } else {
        // Wait for the service worker to be activated
        await new Promise((resolve) => {
          if (registration.installing) {
            registration.installing.addEventListener("statechange", (e) => {
              if (e.target.state === "activated") {
                console.log("Service worker activated")
                resolve()
              }
            })
          } else if (registration.waiting) {
            registration.waiting.addEventListener("statechange", (e) => {
              if (e.target.state === "activated") {
                console.log("Service worker activated")
                resolve()
              }
            })
          } else {
            // Already activating or activated
            resolve()
          }
        })
      }

      return registration
    } catch (error) {
      console.error("Service Worker registration failed:", error)
      throw error
    }
  } else {
    console.warn("Service workers are not supported in this browser")
    throw new Error("Service workers not supported")
  }
}

// Request permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    console.log("Requesting notification permission...")

    // Register service worker first
    await registerServiceWorker()

    // Request permission
    const permission = await Notification.requestPermission()

    if (permission === "granted") {
      console.log("Notification permission granted.")

      // Get new token
      const currentToken = await getFirebaseToken(messaging, {
        vapidKey: "BMeFqKDNr08nTY15uuVfSUvCkvdsMbCLitBJ_71POxc5hcptu69Z23BX_HIOwsD_1QY2eHngRwfBkjvmohFI9B8",
        serviceWorkerRegistration: serviceWorkerRegistration,
      })

      if (currentToken) {
        console.log("Current token:", currentToken)
        return currentToken
      } else {
        console.error("No registration token available. Request permission to generate one.")
        throw new Error("No registration token available")
      }
    } else {
      console.warn("Notification permission denied.")
      throw new Error("Notification permission denied")
    }
  } catch (error) {
    console.error("Error getting notification token:", error)
    throw error
  }
}

// Delete the current FCM token
export const deleteToken = async () => {
  try {
    await deleteFirebaseToken(messaging)
    console.log("FCM token deleted successfully")
    return true
  } catch (error) {
    console.error("Error deleting FCM token:", error)
    return false
  }
}

// Updated: Save token to database using the Lambda function
export const saveTokenToDatabase = async (userId, token) => {
  try {
    if (!userId || !token) {
      console.error("Missing userId or token for saving to database")
      return false
    }

    console.log(`Saving token for user ${userId} via Lambda function`)

    // Use the dedicated Lambda function URL
    const response = await fetch("https://tvaf32pm2tarajmrxaxyy3pp3e0zgjyx.lambda-url.ap-south-1.on.aws/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        request: "savetoken",
        body: {
          pid: userId,
          token: token,
        },
      }),
    })

    if (!response.ok) {
      console.error(`Error response from server: ${response.status} ${response.statusText}`)
      return false
    }

    const data = await response.json()
    console.log("Token save response:", data)

    if (data.success) {
      console.log(`Token saved successfully. User now has ${data.tokenCount} device(s) registered.`)
      return true
    } else {
      console.error("Failed to save token:", data.error || "Unknown error")
      return false
    }
  } catch (error) {
    console.error("Error saving token to database:", error)

    // Retry once after a short delay
    try {
      console.log("Retrying token save after error...")
      await new Promise((resolve) => setTimeout(resolve, 2000))

      const retryResponse = await fetch("https://tvaf32pm2tarajmrxaxyy3pp3e0zgjyx.lambda-url.ap-south-1.on.aws/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          request: "savetoken",
          body: {
            pid: userId,
            token: token,
          },
        }),
      })

      if (retryResponse.ok) {
        const retryData = await retryResponse.json()
        if (retryData.success) {
          console.log("Token saved successfully on retry")
          return true
        }
      }
    } catch (retryError) {
      console.error("Retry also failed:", retryError)
    }

    return false
  }
}

// Add an alternative method to save the token if WebSocket fails
const saveTokenAlternative = async (userId, token) => {
  try {
    console.log("Using alternative method to save token")

    // Create multiple WebSocket connections to increase chances of success
    const promises = []

    for (let i = 0; i < 2; i++) {
      promises.push(
        new Promise((resolve) => {
          const ws = new WebSocket("wss://agwbedbhbi.execute-api.ap-south-1.amazonaws.com/development/")

          const timeout = setTimeout(() => {
            console.log(`Alternative connection ${i + 1} timed out`)
            ws.close()
            resolve(false)
          }, 8000)

          ws.onopen = () => {
            console.log(`Alternative connection ${i + 1} opened`)

            // Send token directly without waiting
            ws.send(
              JSON.stringify({
                action: "saveDeviceToken",
                pid: userId,
                deviceToken: token,
              }),
            )

            // Close after sending
            setTimeout(() => {
              clearTimeout(timeout)
              ws.close()
              console.log(`Alternative connection ${i + 1} closed after sending`)
              resolve(true)
            }, 1000)
          }

          ws.onerror = () => {
            clearTimeout(timeout)
            ws.close()
            resolve(false)
          }
        }),
      )
    }

    // If any connection succeeds, consider it a success
    const results = await Promise.all(promises)
    return results.some((result) => result === true)
  } catch (error) {
    console.error("Error in alternative token save method:", error)
    return false
  }
}

// New: Remove specific token from database
export const removeTokenFromDatabase = async (userId, token) => {
  try {
    if (!userId || !token) {
      console.error("Missing userId or token for removal from database")
      return false
    }

    console.log(`Removing specific token for user ${userId} via Lambda function`)

    const response = await fetch("https://tvaf32pm2tarajmrxaxyy3pp3e0zgjyx.lambda-url.ap-south-1.on.aws/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        request: "deletetoken",
        body: {
          pid: userId,
          token: token, // Specify the token to remove
        },
      }),
    })

    if (!response.ok) {
      console.error(`Error response from server: ${response.status} ${response.statusText}`)
      return false
    }

    const data = await response.json()
    console.log("Token removal response:", data)

    if (data.success) {
      console.log("Token removed successfully")
      return true
    } else {
      console.error("Failed to remove token:", data.error || "Unknown error")
      return false
    }
  } catch (error) {
    console.error("Error removing token from database:", error)
    return false
  }
}

// Check if user has tokens
export const checkUserTokens = async (userId) => {
  try {
    if (!userId) {
      console.error("Missing userId for token check")
      return { hasTokens: false, tokens: [] }
    }

    const response = await fetch("https://tvaf32pm2tarajmrxaxyy3pp3e0zgjyx.lambda-url.ap-south-1.on.aws/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        request: "checktoken",
        body: {
          pid: userId,
        },
      }),
    })

    if (!response.ok) {
      console.error(`Error response from server: ${response.status} ${response.statusText}`)
      return { hasTokens: false, tokens: [] }
    }

    const data = await response.json()
    console.log("Token check response:", data)

    return {
      hasTokens: data.hasTokens || false,
      tokenCount: data.tokenCount || 0,
      tokens: data.tokens || [],
    }
  } catch (error) {
    console.error("Error checking tokens:", error)
    return { hasTokens: false, tokens: [] }
  }
}

// Set up foreground message handler
export const onForegroundMessage = (callback) => {
  return onMessage(messaging, (payload) => {
    console.log("Message received in the foreground:", payload)
    callback(payload)
  })
}

// Request permission and get token (alternative function name)
export const requestPermissionAndGetToken = async (userId) => {
  try {
    const token = await requestNotificationPermission()
    if (token) {
      await saveTokenToDatabase(userId, token)
    }
    return token
  } catch (error) {
    console.error("Error in requestPermissionAndGetToken:", error)
    return null
  }
}

// Set up foreground message handler (alternative function name)
export const setupForegroundMessageHandler = onForegroundMessage

// Updated: Clean up FCM token when logging out
export const cleanupFcmToken = async (userId, token) => {
  if (!userId || !token) {
    console.warn("Missing userId or token for cleanup")
    return false
  }

  try {
    // Remove the token from the database
    const removed = await removeTokenFromDatabase(userId, token)

    // Optionally delete the token from Firebase
    // await deleteToken()

    console.log("FCM token cleanup result:", removed)
    return removed
  } catch (error) {
    console.error("Error during FCM token cleanup:", error)
    return false
  }
}

// Add this new function to handle background notifications
export const setupBackgroundNotificationHandling = async (userId) => {
  try {
    // Register service worker if not already registered
    await registerServiceWorker()

    // Get token if permission is already granted
    if (Notification.permission === "granted") {
      const token = await requestNotificationPermission()
      if (token && userId) {
        await saveTokenToDatabase(userId, token)
        return token
      }
    }
    return null
  } catch (error) {
    console.error("Error setting up background notification handling:", error)
    return null
  }
}